import React from "react";
import Testimonials from "../home/Testimonials";

const IntegrationsTestimonials = () => {
  return <Testimonials />;
};

export default IntegrationsTestimonials;
